export const AGENT_HUB_AFFILIATION_OPTIONS: Array<App.AgentHubAgencyAffiliations> = [
  '1000 Mile Travel Group',
  'ATAC',
  'CT Partners',
  'Express Travel Group',
  'FBI Travel',
  'FC Independent',
  'Flight Centre Brand',
  'Flight Centre Business Travel',
  'Goldman Travel Corporation',
  'Helloworld',
  'Helloworld Associate',
  'Helloworld Branded',
  'Helloworld Business Travel',
  'House of Travel',
  'Independent (no affiliation)',
  'Independent Travel Group (part of ETG)',
  'italktravel & cruise',
  'itravel Australia Group',
  'Magellan Travel Group',
  'MTA Travel',
  'My Travel Group',
  'Platinum Travel Management',
  'Pulse Travel',
  'Savenio',
  'Select Travel Service',
  'Smartflyer Australia Pty Ltd',
  'Travel Associates',
  'Travel at 60',
  'Travel Partners',
  'Travellers Choice Limited',
  'TravelManagers Australia',
  'Other (please specify)',
]
